import { lightTheme } from '../../../../styles/theme'

// External brand colors of the file formats (Excel green, PDF red, Word blue) —
// constants outside the theme palette, not theme tokens.
const FILE_TYPE_COLORS: Record<string, string> = {
  '.xls': '#1E7145',
  '.xlsx': '#1E7145',
  '.csv': lightTheme.colors.icon,
  '.pdf': '#B42318',
  '.doc': '#2B579A',
  '.docx': '#2B579A',
  '.txt': '#5C7B95',
}

export const DEFAULT_FILE_TYPE_COLOR = lightTheme.colors.icon

export const getFileTypeColor = (extension: string): string =>
  FILE_TYPE_COLORS[extension.toLowerCase()] ?? DEFAULT_FILE_TYPE_COLOR
